export const PRODUCTION = "production";
export const STAGING = "staging";
export const DEVELOPMENT = "development";
export const LOCAL = "local";
